var _path, _path2, _path3, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoreShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 97,
    viewBox: "0 0 82 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.039 14.0947V3.2043C32.6716 1.6027 7.04673 8.3292 2.56288 17.6183C-3.20327 59.5792 12.8123 85.5245 39.3985 91.9308V77.5167C6.72646 75.9151 -6.08625 22.4228 40.039 14.0947Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2786 14.0938V2.79031C49.646 1.18872 74.6304 8.23563 79.1142 17.5247C86.8025 59.5781 68.8648 85.8438 42.2786 92.25V77.4231C74.9507 75.8215 88.4038 22.4218 42.2786 14.0938Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 0C13.858 0 0.886815 15.2229 0.346222 15.8714C0.122931 16.1431 0.000668118 16.4829 0 16.8336L0 47.1589C0 72.8089 23.7678 88.0379 33.9844 93.3948C34.3382 93.5575 34.7415 93.5792 35.1109 93.4552C35.4803 93.3313 35.7877 93.0713 35.9696 92.7288C36.1516 92.3863 36.1942 91.9875 36.0888 91.6147C35.9833 91.242 35.7377 90.9236 35.4027 90.7254C23.3153 84.3883 3.03704 70.3025 3.03704 47.1558V17.4067C5.16904 15.1294 17.1046 3.54106 39.4815 3.03433V95.0115C39.4813 95.3179 39.5751 95.6171 39.7504 95.8692C39.9257 96.1213 40.1742 96.3145 40.4627 96.4229C40.7513 96.5313 41.0662 96.5498 41.3657 96.4761C41.6651 96.4023 41.9348 96.2396 42.1389 96.0098C47.1105 93.8864 82 77.8672 82 46.7517V16.5893C82 16.238 81.8765 15.8977 81.6507 15.6271C81.2013 15.0872 70.3712 2.43109 47.8151 0.171926C47.4154 0.136305 47.0174 0.257417 46.7064 0.509368C46.3954 0.761319 46.196 1.12411 46.1508 1.52018C46.1307 1.71725 46.1498 1.91632 46.2071 2.10605C46.2644 2.29577 46.3588 2.47242 46.4849 2.62591C46.6109 2.7794 46.7662 2.90672 46.9418 3.00061C47.1174 3.09449 47.3099 3.1531 47.5084 3.17308C66.6022 5.08538 76.9767 15.0721 78.963 17.1684V46.7517C78.963 73.753 50.5272 88.8252 42.5185 92.5351V1.50812C42.5185 1.10814 42.3585 0.724545 42.0738 0.441718C41.789 0.158891 41.4027 0 41 0Z",
    fill: "#151515"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.2561,
    cy: 45.6923,
    rx: 31.9748,
    ry: 31.8312,
    fill: "#A7E5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreShieldIcon);
export default __webpack_public_path__ + "static/media/score-shield--icon.4724b7d47ee672cb42ebe7ab156830d8.svg";
export { ForwardRef as ReactComponent };